import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import { pluralize } from 'util/strings'
import themeVars from 'ui_theme/site/globals/site.variables'
import { Avatar, Tooltip } from 'shared/ui'
import { Label } from 'shared/components/ui/Typography'

function colorForType({ type }) {
  switch (type) {
    case 'typing':
      return themeVars.sea
    case 'replying':
      return themeVars.groovy
    case 'noting':
      return themeVars.darkGolden
    case 'viewing':
    default:
      return themeVars.sky
  }
}

function labelForUsers(users, type) {
  if (!users || (users && users.length <= 0)) return null

  const names = users.map(user => user.first_name)
  const rest = users.length - 1

  const label =
    names.length === 1
      ? `${names[0]} is`
      : `${names[0]} and ${rest} ${pluralize(rest, 'agent')} are`

  return (
    <Label
      size="small"
      color="white"
      css={`
        position: relative;
        top: -1px;

        &&& {
          font-family: ${themeVars.walsheim} !important;
        }
      `}
    >
      {label} {type === 'noting' ? 'leaving a note' : type}
    </Label>
  )
}

const Container = styled('div')`
  display: flex;
  align-items: center;
  background-color: ${colorForType};
  border-radius: ${themeVars.defaultBorderRadius};
  overflow: hidden;
`

const label = css`
  padding: ${themeVars.mini};
  padding-right: ${themeVars.large};
  white-space: nowrap;
`
// eslint-disable-next-line react/no-multi-comp
export default function AgentsChip({ users, type }) {
  const [firstUser, ...restUsers] = users

  return (
    <Container type={type}>
      <Avatar actor={firstUser} size={32} radius={0} />
      <Tooltip
        position="top"
        className={label}
        tooltip={
          restUsers.length >= 1 && restUsers.map(user => user.name).join(', ')
        }
      >
        {labelForUsers(users, type)}
      </Tooltip>
    </Container>
  )
}
